import fullPageLoaderHtml from './fullpageloader.component.html';

class FullPageLoaderController {
    constructor($scope, FullPageLoaderService) {
        'ngInject';
        
        this.service = FullPageLoaderService;
    }
}

let fullPageLoaderComponent = {
    bindings: {},
    template: fullPageLoaderHtml,
    controller: FullPageLoaderController
}

export default fullPageLoaderComponent;